
//each snapshot is going to be limited to what type of change it is
import { Text } from '@fluentui/react';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';

interface IAction {
    name: string;
    primary?: boolean;
    onClick?: () => void;
    disabled?: boolean;
}

interface IProps {
    hidden?: boolean;
    title?: string;
    message?: string;
    onRenderMessage?: () => JSX.Element;
    actions?: IAction[];
    onDismiss?: () => void;
}

const ConfirmationDialog = (props: IProps) => {

    const modelProps = {
        isBlocking: true,
        styles: { main: { maxWidth: 650 } },
    };

    const dialogContentProps = {
        type: DialogType.largeHeader,
        title: props.title,
        // subText: props.message,
    };

    const onRenderMessage = props.onRenderMessage
        ? props.onRenderMessage
        : () => {
            return <Text>
                {props.message ?? ''}
            </Text>
        }

    return (
        <Dialog minWidth={600} hidden={props.hidden ?? false} onDismiss={props.onDismiss} dialogContentProps={dialogContentProps} modalProps={modelProps}            >
            {onRenderMessage()}
            <DialogFooter>
                {props.actions?.map(q => {
                    return q.primary
                        ? <PrimaryButton key={q.name} onClick={q.onClick} disabled={q.disabled} text={q.name} />
                        : <DefaultButton key={q.name} onClick={q.onClick} disabled={q.disabled} text={q.name} />
                })}
            </DialogFooter>
        </Dialog>
    );
}

export default ConfirmationDialog;
